import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
export const Error404Desert = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 480 246"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "sfafhixb3a",
  d: "M92.568 42.663c-55.357 0-74.757 13.867-90.679 84.525-7.577 33.623 20.384 26.052 64.872 18.481 49.005-8.338 118.061-16.677 181.766 30.037 35.803 26.254 136.102-2.045 170.672-37.705 8.998-9.285 10.202-19.032 9.882-30.667-.331-12.019-18.844-22.126-31.5-38.802-14.204-18.715-24.415-43.41-59.608-43.41-83.36 0-74.66-24.32-156.272-24.32-47.74 0-53.531 41.861-89.133 41.861z"
}), /*#__PURE__*/React.createElement("path", {
  id: "lkar4wrrhc",
  d: "M.581 42.5v.235C.581 66.215 13.565 85 33.473 85s33.108-19.019 33.108-42.5v-.235C66.581 18.784 53.489 0 33.689 0 13.781 0 .581 19.019.581 42.5zm13.839.532v-.234c0-16.18 7.427-28.986 19.053-28.986 11.626 0 19.269 13.155 19.269 29.22v.232c0 15.948-7.32 28.986-19.053 28.986-11.734 0-19.269-13.154-19.269-29.218z"
}), /*#__PURE__*/React.createElement("path", {
  id: "zb7vx29z4e",
  d: "M11.507.012c-2.555.371-7.594 7.15-8.036 7.81-.521.781-1.361 12.671-1.755 16.209C.657 33.585.581 33.683.581 43.238.581 63.301 14.655 75 50.088 75s54.386-13.136 56.046-33.134c1.026-12.355.886-10.959-7.129-14.162C92.317 25.03 82.24 23.1 83.166 12.39c.3-3.462-1.333-4.267-2.647-3.921-1.686.445-9.366 3.178-10.402 3.921-.766.55 2.229 9.74-4.668 15.314-1.345 1.088-19.703-11.391-20.492-11.89-4.262-2.689-18.23 6.843-28.49 7.255-3.302.133-3.865.089-4.272.044-.216-.023-.388-.046-.9-.044-.841.006.048-11.311.212-13.351C11.874 5.143 13.445 0 11.661 0c-.049 0-.1.004-.154.012z"
}), /*#__PURE__*/React.createElement("path", {
  id: "369wz5f4tg",
  d: "M.581 34.5c0 19.041 15.459 34.501 34.5 34.501s34.5-15.46 34.5-34.501c0-19.04-15.459-34.5-34.5-34.5S.581 15.46.581 34.5z"
}), /*#__PURE__*/React.createElement("path", {
  id: "kkrkbh5xbi",
  d: "M229.357 3.024c-1.348.078-2.056.041-2.701.002-.635-.038-1.208-.076-2.269-.002-1.372.097-2.505 1.379-6.995 14.953-.271.819-7.182 0-7.182 0s-7.132 16.989-9.483 21.313c-3.901 7.171-14.738 7.853-18.678 10.151-16.269 9.488-42.91.694-60.63 10.517-12.169 6.746-29.945 2.732-46.14-1.282-12.079-2.995-23.278-5.988-30.617-4.519-14.752 2.954-18.35.605-20.015-1.742-1.3-1.834-1.42-3.668-4.756-2.974-7.814 1.625-12.937 10.258-16.418 12.286-4.518 2.634-3.134 10.377 0 13.766 7.237 7.822 25.992 27.632 43.414 33.163C73.401 117.073 124.562 126 162.554 126c37.883 0 86.561-8.927 112.279-17.344 17.027-5.573 26.452-12.032 42.03-33.163 4.881-6.62-16.335-11.29-27.369-15.535-5.325-2.047-8.667-34.694-14.661-31.429-4.332 2.363-15.65 29.398-17.332 29.478-5.591.267-8.157-10.438-8.536-25.347-.197-7.717 4.268-15.482 2.639-21.006-.08-.268-1.032-.147-2.155-.027-1.806.195-4.054.389-3.846-1.032.049-.334.56-2.505.751-7.571.003-.096-6.445-2.521-7.129-2.99-.034-.023-.071-.034-.111-.034-.615 0-2.09 2.58-9.757 3.024z"
}), /*#__PURE__*/React.createElement("path", {
  id: "fpes1hom3k",
  d: "M41.842 18.019c-.582 3.743-2.867.445-5.83 4.444-2.095 2.828-7.715 13.815-10.088 18.117-1.687 3.06-.062 12.896-4.184 19.274-5.495 8.5-16.974 13.604-19.246 14.911-16.41 9.444 77.426 31.746 102.012 34.856 16.016 2.026 29.79 4.837 45.506-16.195 4.922-6.589-23.404-28.049-34.537-32.274-5.372-2.039-8.745-34.532-14.79-31.281-5.498 2.958-13.739 41.8-17.466 38.206-4.011-3.869-8.249-19.256-8.631-34.094-.198-7.682 3.871-15.303 2.662-20.907-.146-.674-1.564-.518-2.994-.363-1.626.176-3.266.353-3.061-.692.066-.33.567-2.492.758-7.534.003-.074-4.532-1.564-6.428-2.417-.62-.278-4.142-2.778-12.615-.559-2.612.683-5.387-1.036-6.188-1.257C46.11.086 45.602 0 45.177 0c-3.413 0-1.394 5.521-3.335 18.019z"
}), /*#__PURE__*/React.createElement("path", {
  id: "kndskvmr9m",
  d: "M261.619.043s-12.983 12.684-28.289 14.43c-5.958.679-9.572-.992-17.178-2.663-8.375-1.839-21.592-3.679-48.112-2.382-8.834.432-12.793.257-15.844.081-2.566-.147-4.491-.294-8.135-.081-14.994.879-47.17 14.157-65.98 5.276C46.7-.113 38.419 22.032 25.724 28.324 15.486 33.4-4.771 48.453 1.902 52.462c1.904 1.144 11.705.761 19.735.378 4.399-.209 8.267-.419 10.018-.378 42.286 1 8.322 17.547 23.533 20.543 9.806 1.931 15.794-.973 24.521-3.877 14.693-4.89 37.149-9.78 98.663 8.41 36.907 10.915 101.013-17.599 130.682-24.429 5.092-1.172 10.804.15 16.507 1.472 12.578 2.916 25.109 5.832 30.83-18.024 1.88-7.837-10.586-26.567-22.864-31.298C321.243.526 284.58 0 268.883 0c-4.489 0-7.264.043-7.264.043z"
}), /*#__PURE__*/React.createElement("path", {
  id: "yyc6lcor4o",
  d: "M261.597.043s-13.339 10.941-28.647 12.685c-5.904.674-9.428-.571-16.806-1.816-8.272-1.396-21.393-2.792-48.147-1.484-8.836.432-12.796.257-15.847.081-2.567-.147-4.492-.294-8.138-.081-14.997.879-46.878 13.535-65.994 5.276-36.235-15.655-44.386 6.512-52.37 13.62-8.462 7.535-30.502 20.129-23.827 24.138 1.904 1.144 11.707.761 19.741.378 4.399-.209 8.268-.419 10.019-.378 42.295 1 8.323 17.547 23.539 20.543 9.807 1.931 15.797-.973 24.526-3.877 14.696-4.89 37.157-9.78 98.686 8.41 36.914 10.915 101.035-17.599 130.711-24.429 5.093-1.172 10.806.15 16.51 1.472 12.582 2.916 25.115 5.832 30.838-18.024 1.881-7.837-10.588-26.567-22.87-31.298C321.235.526 284.564 0 268.863 0c-4.49 0-7.266.043-7.266.043z"
}), /*#__PURE__*/React.createElement("path", {
  id: "cfbzaufbeq",
  d: "M64.727.828c-5.996 1.548-15.141 19.2-22.176 24.381-12.134 8.939-34.496 6.9-39.688 12.488-2.963 3.19-2.952 12.485 0 15.695 4.713 5.123 19.755 9.154 28.274 15.047 16.741 11.581 64.801 28.19 96.499 23.487 23.301-3.458 50.871-5.767 51.385-23.487.392-13.452 14.09-7.989 21.855-27.438 4.71-11.8-19.814-15.285-26.168-16.791-4.394-1.041-9.428 8.186-14.481 8.438-8.579.427-26.637-1.73-37.401-5.328-9.583-3.205-17.668-12.653-27.177-16.268C84.81 6.931 71.923.677 66.095.677c-.512 0-.971.049-1.368.151z"
}), /*#__PURE__*/React.createElement("path", {
  id: "410w9fjrhs",
  d: "M101.27 2.098c.208 1.5 13.229 6.048 9.968 9.004-3.263 2.956-21.836 5.08-29.542 8.729-7.181 3.4-9.702 10.247-16.702 13.169-2.92 1.219-7.873 1.168-12.628 1.117-6.645-.072-12.901-.144-12.675 3.254.139 2.088 18.005 13.126-13.094 15.939-7.121.646-9.821.045-14.194-.797-4.399-.847-9.057 2.794-10.489 3.371-6.376 2.569 12.098 13.565 13.818 13.102 7.932-2.139 61.158-18.499 94.253-19.237 15.869-.354 40.175 4.569 64.352 9.491 36.143 7.359 71.999 14.718 78.949 4.448 3.278-4.844-.107-4.232-5.247-3.618-3.364.402-7.481.803-10.971-.327-5.82-1.884-12.047-6.287-15.484-7.23-12.416-3.405-38.777 3.157-61.778-10.804-17.689-10.736-25.038-5.65-31.462-11.763-4.693-4.465 16.043-7.369 16.647-10.115.603-2.746-9.236-3.875-13.025-6.361-3.872-2.54-6.543-6.982-10.206-8.879-3.173-1.641-8.798-1.175-11.775-2.493C106.484.546 104.355 0 103.075 0c-1.9 0-1.931 1.201-1.805 2.098z"
}), /*#__PURE__*/React.createElement("path", {
  id: "5kvlj41luu",
  d: "M97.894.181c-3.655 1.276 20.616 1.297-7.64 15.759-5.853 2.996-22.004 5.185-25.853 13.649-1.307 2.872-1.299 10.02-3.68 11.652C41.51 54.413-3.056 44.399.818 60.848c2.736 11.62 151.318 14.479 188.838 2.142 8.474-2.786 5.176-6.231-3.547-8.254-17.049-3.951-48.657-6.295-56.26-13.495-2.199-2.08-9.63-12.034-24.495-11.652-6.157.159-8.566-4.216-7.46-7.665 1.139-3.551 14.291-10.017 14.291-13.639 0-3.274-8.675-8.284-13.049-8.285-.469 0-.888.058-1.242.181z"
}), /*#__PURE__*/React.createElement("path", {
  id: "9sg07k07bw",
  d: "M.88.337C.481.891.481 3.109.88 3.663c.324.449 2.077.449 2.402 0 .398-.554.398-2.772 0-3.326C3.119.112 2.6 0 2.081 0S1.042.112.88.337z"
}), /*#__PURE__*/React.createElement("path", {
  id: "8u3mje67xy",
  d: "M.609.79c.209.9 1.606 4.172 2.097 4.909.397.597 1.015.239.846-.489-.208-.9-1.606-4.173-2.096-4.909C1.317.092 1.151 0 1.001 0 .722 0 .5.317.609.79z"
}), /*#__PURE__*/React.createElement("path", {
  id: "2p6cr2fr1A",
  d: "M2.481.22C1.986.897.655 4.1.483 5.026c-.138.75.568 1.299.968.753C1.945 5.104 3.276 1.9 3.448.974 3.547.435 3.211 0 2.866 0c-.135 0-.272.067-.385.22z"
}), /*#__PURE__*/React.createElement("path", {
  id: "94v7hps62C",
  d: "M3.992.009c-.609.128-2.77 1.38-3.24 1.878-.381.402-.075 1.208.418 1.103.609-.127 2.769-1.379 3.239-1.877C4.767.735 4.52 0 4.079 0c-.028 0-.057.003-.087.009z"
}), /*#__PURE__*/React.createElement("path", {
  id: "3bksn22gqE",
  d: "M.598.641c.164.616 1.487 2.754 1.981 3.209.4.366 1.12.009.985-.491C3.398 2.743 2.076.604 1.582.151 1.468.046 1.327 0 1.187 0 .84 0 .501.284.598.641z"
}), /*#__PURE__*/React.createElement("path", {
  id: "cx99hkttdG",
  d: "M.936 37.931c0 20.935-2.208 29.662 4.383 35.732 2.693 2.478 23.249 4.327 25.686-1.726 2.836-7.042-5.931-13.292-1.967-34.006.125-.653.241-1.301.348-1.941C33.039 14.089 26.133.001 17.338.001 8.286.001.936 16.996.936 37.931z"
}), /*#__PURE__*/React.createElement("path", {
  id: "atdvy0jgnI",
  d: "M2.099.339C1.598 1.098.587 4.391.581 5.279c-.006.719 1.077.998 1.482.382.501-.759 1.513-4.053 1.518-4.939C3.584.277 3.17 0 2.758 0c-.253 0-.505.105-.659.339z"
}), /*#__PURE__*/React.createElement("path", {
  id: "899plzbcbK",
  d: "M2.099.338C1.597 1.098.587 4.391.581 5.279c-.006.719 1.077.998 1.482.382.499-.759 1.512-4.053 1.518-4.939C3.584.276 3.169 0 2.758 0c-.253 0-.506.104-.659.338z"
}), /*#__PURE__*/React.createElement("path", {
  id: "rfohlxrohM",
  d: "M2.254.245C1.755.76.64 2.963.582 3.548c-.046.475.921.626 1.325.208.499-.515 1.616-2.719 1.672-3.304C3.607.168 3.273 0 2.914 0c-.243 0-.497.076-.66.245z"
}), /*#__PURE__*/React.createElement("path", {
  id: "jurc083s0O",
  d: "M3.424.154C2.77.686.9 3.315.62 4.097c-.227.632.588 1.18 1.117.749.654-.532 2.524-3.16 2.805-3.942C4.713.427 4.294 0 3.851 0c-.146 0-.296.047-.427.154z"
}), /*#__PURE__*/React.createElement("path", {
  id: "oqqdu1yz9Q",
  d: "M.582.773c.054.897 1.161 4.175 1.661 4.918.405.6 1.38.263 1.336-.465C3.524 4.33 2.418 1.052 1.918.31 1.774.095 1.556 0 1.338 0 .947 0 .554.307.582.773z"
}), /*#__PURE__*/React.createElement("path", {
  id: "gqs849fk6S",
  d: "M.582.773c.055.897 1.162 4.175 1.661 4.918.405.6 1.38.263 1.336-.465C3.525 4.33 2.418 1.052 1.918.31 1.773.095 1.556 0 1.338 0 .946 0 .554.307.582.773z"
}), /*#__PURE__*/React.createElement("path", {
  id: "7e5gljmmrU",
  d: "M.582.773c.055.897 1.161 4.175 1.661 4.918.404.6 1.38.262 1.336-.464C3.524 4.33 2.417 1.052 1.918.31 1.774.095 1.556 0 1.338 0 .946 0 .554.307.582.773z"
}), /*#__PURE__*/React.createElement("path", {
  id: "x9yvr69o5W",
  d: "M.582.773c.055.897 1.161 4.176 1.662 4.917.404.601 1.379.263 1.335-.463C3.524 4.33 2.417 1.052 1.918.31 1.773.095 1.556 0 1.338 0 .947 0 .554.307.582.773z"
}), /*#__PURE__*/React.createElement("path", {
  id: "v8sx1h4lmY",
  d: "M.582.774c.055.896 1.161 4.175 1.662 4.916.404.601 1.379.263 1.335-.463-.054-.896-1.162-4.175-1.661-4.918C1.773.095 1.556 0 1.339 0 .947 0 .554.307.582.774z"
}), /*#__PURE__*/React.createElement("path", {
  id: "ew24o4vv4aa",
  d: "M.585.471c.094.59 1.277 2.788 1.775 3.296.405.415 1.291.239 1.216-.238C3.484 2.939 2.301.742 1.801.231 1.645.071 1.416 0 1.199 0 .855 0 .539.179.585.471z"
}), /*#__PURE__*/React.createElement("path", {
  id: "mkzx1s0r4ac",
  d: "M2.719.173C2.229.644.824 2.805.61 3.414c-.172.494.436.795.834.413.326-.313 1.057-1.377 1.573-2.233.258-.428.463-.805.534-1.007C3.669.249 3.421 0 3.126 0c-.136 0-.282.053-.407.173z"
}), /*#__PURE__*/React.createElement("path", {
  id: "s0maz4s98ae",
  d: "M2.596.11C2.102.449.77 2.05.598 2.514c-.139.374.567.649.967.376.33-.226 1.031-1.011 1.512-1.648.242-.319.428-.6.485-.756C3.663.217 3.327 0 2.981 0c-.135 0-.272.033-.385.11z"
}), /*#__PURE__*/React.createElement("path", {
  id: "g2c5cx47yag",
  d: "M24.425.026c-1.471.826-5.612 4.438-8.825 6.086C11.664 8.13 2.945 12.075.814 12.136c-1.663.046 6.031 2.482 8.967 1.715 3.447-.901 9.271-5.251 11.711-7.119 1.365-1.042 2.444-3.154 2.933-4.081.234-.449 0-1.053 0-1.491 0-.343.29-1.16.08-1.16-.021 0-.048.008-.08.026z"
}), /*#__PURE__*/React.createElement("path", {
  id: "ds4jfa05rai",
  d: "M24.874 1.623C18.182 7.15 12.691 17.516 7.542 22.474c-1.235 1.218-2.643 2.44-4.303 3.359-.749.416-1.486 1.76-2.023 2.423-2.567 3.164 9.359 5.654 14.23 4.914 4.872-.741 13.823-5.232 14.995-9.359 1.172-4.124 4.657-14.496 2.121-15.194-1.366-.378-.974-4.867-2.463-6.994C29.624.944 28.73.614 27.754.614c-.994 0-2.072.342-2.88 1.009z"
}), /*#__PURE__*/React.createElement("path", {
  id: "oa2uffvwwak",
  d: "M16.806 2.942C11.714 5.679 9.8 16.44 4.479 21.424c-1.324 1.242-1.349 2.048-3.206 2.913-.826.384-.809.837-.485 1.084.534.407.211.767 3.691 1.358 4.393.745 13.293.219 12.327-11.459C16.445 10.965 24.727 1 22.044.167 21.677.052 21.379 0 21.125 0c-1.323 0-1.482 1.418-4.319 2.942z"
}), /*#__PURE__*/React.createElement("path", {
  id: "t2cba7tp6am",
  d: "M1.048 16.735c-1.874 2.46 2.55 12.182 1.804 15.219-2.133 8.684 7.721 21.511 8.05 21.033 1.308-1.896 6.333-10.313 3.575-14.182-.429-.599.575-3.119 0-6.139-2.313-12.132 6.314-16.843 1.748-25.826-.53-1.044-3.439 4.079-5.323 5-2.48 1.212-4-1.548-4.124-2.281-.318-1.89 2.551-8.475 0-9.383C6.443.057 6.148 0 5.886 0c-3.67.002-.587 11.157-4.838 16.735z"
}), /*#__PURE__*/React.createElement("path", {
  id: "s88lwhjuwao",
  d: "M17.584.721c-1.328.517-2.851 2.051-2.556 3.459 1.823 8.729-3.122 8.387-9.996 7.268-1.364-.224-3.454-.714-4.144 0-.69.712 0 2.853 0 4.28 0 1.744-.69 5.58 0 6.187.69.605 2.571-2.172 4.144-2.548.854-.205 1.906-.09 3.001.025 1.175.123 2.399.247 3.486-.025 2.423-.607 5.985-1.817 8.05-3.639 2.066-1.822 3.618-4.795 4.342-7.296.714-2.467 1.055-6.425 0-7.711C23.476.19 22.572 0 21.557 0c-1.44 0-3.105.383-3.973.721z"
}), /*#__PURE__*/React.createElement("path", {
  id: "0gcxtp5quaq",
  d: "M1.167.722c-.923 1.285-.626 5.243 0 7.71.633 2.5 1.991 5.473 3.799 7.296 1.806 1.822 4.924 3.032 7.043 3.638.951.273 2.024.149 3.052.025.957-.114 1.878-.229 2.626-.025 1.376.377 3.021 3.155 3.626 2.548.604-.606 0-4.442 0-6.186 0-1.427.604-3.568 0-4.281-.605-.713-2.434-.222-3.626 0C11.671 12.568 7.344 12.91 8.94 4.18 9.198 2.771 7.864 1.238 6.703.722 5.943.384 4.487 0 3.227 0c-.888 0-1.679.191-2.06.722z"
}), /*#__PURE__*/React.createElement("path", {
  id: "8fjrlx2iras",
  d: "M3.424.153C2.769.685.9 3.314.62 4.097c-.227.633.588 1.18 1.117.749.654-.533 2.524-3.16 2.805-3.943C4.713.427 4.294 0 3.851 0c-.147 0-.296.047-.427.153z"
}), /*#__PURE__*/React.createElement("path", {
  id: "hfmzjthfuau",
  d: "M2.255.245C1.754.76.64 2.963.582 3.548c-.048.475.92.626 1.323.208.501-.515 1.615-2.719 1.674-3.304C3.607.168 3.273 0 2.913 0c-.242 0-.496.076-.658.245z"
}), /*#__PURE__*/React.createElement("path", {
  id: "wg0euknjfaw",
  d: "M2.457.26C1.959.968.715 4.21.589 5.123c-.1.739.713 1.191 1.116.618.496-.709 1.741-3.951 1.867-4.864C3.641.371 3.282 0 2.919 0c-.167 0-.335.079-.462.26z"
}), /*#__PURE__*/React.createElement("path", {
  id: "z8g1ar147ay",
  d: "M.581 72.383c1.742.826 3.407.819 5 0V.137C3.991.792 2.316.572.581 0v72.383z"
}), /*#__PURE__*/React.createElement("path", {
  id: "44ihsdfyraA",
  d: "M2.035.272c-.441.021-.977.01-1.454 0 .002 5.698.015 11.397 0 17.095.003 17.673.001 35.346 0 53.019 1.293.616 2.171.654 3 .593V.272c-.298.107-.611.071-.937.034C2.479.288 2.31.269 2.139.269c-.035 0-.069.001-.104.003z"
}), /*#__PURE__*/React.createElement("path", {
  id: "knmkc3jd8aC",
  d: "M.581 1c0 .552 1.12 1 2.5 1s2.5-.448 2.5-1c0-.551-1.12-1-2.5-1s-2.5.449-2.5 1z"
}), /*#__PURE__*/React.createElement("path", {
  id: "quj352zmqaE",
  d: "M.582.774c.054.896 1.161 4.174 1.661 4.917.405.6 1.38.262 1.336-.465C3.524 4.33 2.417 1.052 1.918.31 1.773.095 1.556 0 1.338 0 .947 0 .554.307.582.774z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(9)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "odyz6pifzb",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#sfafhixb3a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-4.347 190.971L434.126 190.971 434.126 -4.198 -4.347 -4.198z",
  mask: "url(#odyz6pifzb)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(182 43)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "u9z50ymu7d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#lkar4wrrhc"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#DF1B12",
  d: "M-4.419 90L71.581 90 71.581 -5 -4.419 -5z",
  mask: "url(#u9z50ymu7d)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#DF1B12",
  d: "M153.057 54.3l-31.476 43.943 3.434 9.573 32.008-3.422 1.516 13.605 13.759-1.47-1.515-13.606 8.798-.942-1.255-11.263-8.798.94L165.225 53 153.057 54.3zm.526 19.184l2.187 19.645-17.409 1.861 15.222-21.505zM250.581 84.694l1.18 10.255 32.526 3.645-1.659 13.84L296.609 114l1.658-13.842 8.94 1.003 1.374-11.457-8.94-1.002 4.713-39.319-12.364-1.383-41.409 36.693zm17.39.462l20.083-18-2.394 19.981-17.689-1.98z",
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(172 75)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "9cytn3447f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#zb7vx29z4e"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-4.419 80L111.581 80 111.581 -5 -4.419 -5z",
  mask: "url(#9cytn3447f)",
  opacity: ".288"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(184 96)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "4au76v1klh",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#369wz5f4tg"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EAEAEA",
  d: "M-4.419 74L74.581 74 74.581 -5 -4.419 -5z",
  mask: "url(#4au76v1klh)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(125 61)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "6m8nyyn8uj",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#kkrkbh5xbi"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#5E5E5E",
  d: "M-4.419 131L322.581 131 322.581 -5 -4.419 -5z",
  mask: "url(#6m8nyyn8uj)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(29 60)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "86uvhwuz3l",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#fpes1hom3k"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#AAA",
  d: "M-4.419 116L155.581 116 155.581 -5 -4.419 -5z",
  mask: "url(#86uvhwuz3l)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(0 110)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "bjtf09wu2n",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#kndskvmr9m"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M-4.419 85L361.581 85 361.581 -5 -4.419 -5z",
  mask: "url(#bjtf09wu2n)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(0 110)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "qjjicylxnp",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#yyc6lcor4o"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M-4.419 85L361.581 85 361.581 -5 -4.419 -5z",
  mask: "url(#qjjicylxnp)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(243 97)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "3ss3jahsxr",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cfbzaufbeq"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#AAA",
  d: "M-4.355 97.743L206.473 97.743 206.473 -4.322 -4.355 -4.322z",
  mask: "url(#3ss3jahsxr)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(132 128)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "q4p6snwp3t",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#410w9fjrhs"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#F4F6F8",
  d: "M-4.419 74L259.581 74 259.581 -5 -4.419 -5z",
  mask: "url(#q4p6snwp3t)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(144 132)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "afypbmo5nv",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#5kvlj41luu"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-4.419 76L199.581 76 199.581 -5 -4.419 -5z",
  mask: "url(#afypbmo5nv)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(117 133)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "pd5nxndukx",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#9sg07k07bw"
})), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M-4.419 9L8.581 9 8.581 -5 -4.419 -5z",
  mask: "url(#pd5nxndukx)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(100 131)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "nwyj43qzhz",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#8u3mje67xy"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EF0D0D",
  d: "M-4.419 11L8.581 11 8.581 -5 -4.419 -5z",
  mask: "url(#nwyj43qzhz)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(120 108)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "orng5q93tB",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#2p6cr2fr1A"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EE3E3E",
  d: "M-4.534 11L8.466 11 8.466 -5 -4.534 -5z",
  mask: "url(#orng5q93tB)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(146 145)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "3cz60knspD",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#94v7hps62C"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EF0D0D",
  d: "M-4.419 8L9.581 8 9.581 -5 -4.419 -5z",
  mask: "url(#3cz60knspD)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(137 137)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "9xrd04b1gF",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#3bksn22gqE"
})), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M-4.419 9L8.581 9 8.581 -5 -4.419 -5z",
  mask: "url(#9xrd04b1gF)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(100 111)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "r48zzh5j9H",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cx99hkttdG"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#4F4F4F",
  d: "M-4.419 81L36.581 81 36.581 -5 -4.419 -5z",
  mask: "url(#r48zzh5j9H)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(122 116)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "402bp216gJ",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#atdvy0jgnI"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EE3E3E",
  d: "M-4.419 11L8.581 11 8.581 -5 -4.419 -5z",
  mask: "url(#402bp216gJ)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(122 143)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "jn6w99qmiL",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#899plzbcbK"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EE3E3E",
  d: "M-4.419 11L8.581 11 8.581 -5 -4.419 -5z",
  mask: "url(#jn6w99qmiL)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(117 136)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "bmlm3m4d2N",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#rfohlxrohM"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-4.419 9L8.581 9 8.581 -5 -4.419 -5z",
  mask: "url(#bmlm3m4d2N)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(127 126)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "0cnno9h9cP",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#jurc083s0O"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EE3E3E",
  d: "M-4.419 10L9.581 10 9.581 -5 -4.419 -5z",
  mask: "url(#0cnno9h9cP)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(110 124)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "ucbq6gk50R",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#oqqdu1yz9Q"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-4.419 11L8.581 11 8.581 -5 -4.419 -5z",
  mask: "url(#ucbq6gk50R)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(113 151)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "jly2c363rT",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#gqs849fk6S"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-4.419 11L8.581 11 8.581 -5 -4.419 -5z",
  mask: "url(#jly2c363rT)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(106 114)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "wkxfz0hy7V",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#7e5gljmmrU"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EF0D0D",
  d: "M-4.419 11L8.581 11 8.581 -5 -4.419 -5z",
  mask: "url(#wkxfz0hy7V)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(103 157)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "cjb4r7fv9X",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#x9yvr69o5W"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EF0D0D",
  d: "M-4.419 11L8.581 11 8.581 -5 -4.419 -5z",
  mask: "url(#cjb4r7fv9X)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(85 128)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "sk5tyb5nuZ",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#v8sx1h4lmY"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EF0D0D",
  d: "M-4.419 11L8.581 11 8.581 -5 -4.419 -5z",
  mask: "url(#sk5tyb5nuZ)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(113 108)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mcy4nwaulab",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ew24o4vv4aa"
})), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M-4.419 9L8.581 9 8.581 -5 -4.419 -5z",
  mask: "url(#mcy4nwaulab)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(145 137)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "crw9it5ecad",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#mkzx1s0r4ac"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EF0D0D",
  d: "M-4.419 9L8.581 9 8.581 -5 -4.419 -5z",
  mask: "url(#crw9it5ecad)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(138 149)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "cwuf8cupuaf",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#s0maz4s98ae"
})), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M-4.419 8L8.581 8 8.581 -5 -4.419 -5z",
  mask: "url(#cwuf8cupuaf)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(236 106)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "1u891d89cah",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#g2c5cx47yag"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-4.419 19L29.581 19 29.581 -5 -4.419 -5z",
  mask: "url(#1u891d89cah)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(281 97)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "oc642f4qmaj",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ds4jfa05rai"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-4.143 38.301L38.465 38.301 38.465 -4.386 -4.143 -4.386z",
  mask: "url(#oc642f4qmaj)",
  opacity: ".517"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(337 51)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "gnkz4cbbval",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#oa2uffvwwak"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-4.419 32L27.581 32 27.581 -5 -4.419 -5z",
  mask: "url(#gnkz4cbbval)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(90 66)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "5sov5vhgwan",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#t2cba7tp6am"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-4.419 58L22.581 58 22.581 -5 -4.419 -5z",
  mask: "url(#5sov5vhgwan)",
  opacity: ".517"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(124 138)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "9o4ulvcetap",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#s88lwhjuwao"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#4F4F4F",
  d: "M-4.419 27L29.581 27 29.581 -5 -4.419 -5z",
  mask: "url(#9o4ulvcetap)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(85 133)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "qdihxfeo2ar",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#0gcxtp5quaq"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#4F4F4F",
  d: "M-4.419 27L26.581 27 26.581 -5 -4.419 -5z",
  mask: "url(#qdihxfeo2ar)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(128 148)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "tf6rwq0auat",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#8fjrlx2iras"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EE3E3E",
  d: "M-4.419 10L9.581 10 9.581 -5 -4.419 -5z",
  mask: "url(#tf6rwq0auat)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(141 145)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "7nrim53h9av",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#hfmzjthfuau"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M-4.419 9L8.581 9 8.581 -5 -4.419 -5z",
  mask: "url(#7nrim53h9av)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(93 139)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "zl58blq0nax",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#wg0euknjfaw"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EF0D0D",
  d: "M-4.419 11L8.581 11 8.581 -5 -4.419 -5z",
  mask: "url(#zl58blq0nax)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(316 115)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "eck75c3q1az",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#z8g1ar147ay"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#515151",
  d: "M-4.419 78L10.581 78 10.581 -5 -4.419 -5z",
  mask: "url(#eck75c3q1az)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M292.581 129.829L297.207 135.154 316.58 141 316.58 132.537 307.284 129.877 297.207 126.999z",
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#858585",
  d: "M297.253 126.983L316.58 132.564 316.58 131.036 299.326 126.31z",
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F0F0F0",
  d: "M332.933 137.778L319.581 139.34 319.581 147 340.842 144.557 344.582 139.585 339.599 136.999z",
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#858585",
  d: "M319.581 137.876L319.581 139.325 339.605 136.979 337.212 136z",
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(316 117)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "a7b5jpth7aB",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#44ihsdfyraA"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#C4C4C4",
  d: "M-4.419 76L8.581 76 8.581 -4.731 -4.419 -4.731z",
  mask: "url(#a7b5jpth7aB)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#E5E5E5",
  d: "M309.516 138.877L316.581 141 316.581 133z",
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(316 113)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "idytvw8gpaD",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#knmkc3jd8aC"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#393939",
  d: "M-4.419 7L10.581 7 10.581 -5 -4.419 -5z",
  mask: "url(#idytvw8gpaD)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-80 -1291) translate(80 1291) translate(18 21) translate(102 143)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "bqix3rjx5aF",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#quj352zmqaE"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EF0D0D",
  d: "M-4.419 11L8.581 11 8.581 -5 -4.419 -5z",
  mask: "url(#bqix3rjx5aF)"
})))))));
//# sourceMappingURL=Error404Desert.js.map